import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { ValidateCodeModalPageRoutingModule } from './validate-code-modal-routing.module';

import { ValidateCodeModalPage } from './validate-code-modal.page';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ValidateCodeModalPageRoutingModule
  ],
  declarations: [ValidateCodeModalPage]
})
export class ValidateCodeModalPageModule {}
